<template>
  <NuxtLink href="/" class="logo" aria-label="terug naar de homepage">
    <AppLogoAnimated v-if="props.animate" class="logo__graphic" />
    <component :is="computedValue" v-else class="logo__graphic" />
    <span class="logo__label">terug naar de homepage</span>
  </NuxtLink>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import * as logo from 'assets/svg/logo.svg'

const props = defineProps<{
  animate?: Boolean
}>();

const computedValue = computed(() => {
  return logo
})

</script>

<style scoped lang="postcss">
.logo {
  @mixin focus-ring;

  &__graphic {
    pointer-events: auto;
    height: auto;
  }

  &__label {
    @mixin sr-only;
  }
}
</style>
